import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import * as actions from "../../../../../_redux/advisors/AdvisorsAction";
import * as uiHelpers from "../StudentsUIHelpers";
import { 
  getSelectRow, 
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../../../../_metronic/_partials/controls";
import { useStudentsUIContext } from "../StudentsUIContext";

export function StudentsTable() {
  // Students UI Context
  const studentsUIContext = useStudentsUIContext();
  const studentsUIProps = useMemo(() => {
    return {
      ids: studentsUIContext.ids,
      setIds: studentsUIContext.setIds,
      queryParams: studentsUIContext.queryParams,
      setQueryParams: studentsUIContext.setQueryParams
    };
  }, [studentsUIContext]);

  // Getting curret state of Students list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.advisors }),
    shallowEqual
  );
  const { totalCount, registrationInfoIds, entities, listLoading } = currentState;
  
  // Students Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    studentsUIProps.setIds(registrationInfoIds);
    dispatch(actions.getStudents(studentsUIProps.queryParams));
    return () => dispatch(actions.cleanAdvisorsState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registrationInfoIds, studentsUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "studentName",
      text: "Öğrenci Adı",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "studentSurname",
      text: "Öğrenci Soyadı",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "grade",
      text: "Sınıfı",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "section",
      text: "Şube",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "sexName",
      text: "Cinsiyeti",
      sort: true,
      sortCaret: sortCaret
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: studentsUIProps.queryParams.pageSize,
    page: studentsUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ? entities : [] }
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                studentsUIProps.setQueryParams
              )}
              selectRow={getSelectRow({
                entities,
                ids: studentsUIProps.ids,
                setIds: studentsUIProps.setIds,
              })}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}